export const GET_PROPERTY_STYLES = 'GET_PROPERTY_STYLES';
export const SET_PROPERTY_STYLES = 'SET_PROPERTY_STYLES';
export const GET_PROPERTY_STYLES_ERROR = 'GET_PROPERTY_STYLES_ERROR';

export const GET_ALL_PROPERTY_STYLES = 'GET_ALL_PROPERTY_STYLES';
export const SET_ALL_PROPERTY_STYLES = 'SET_ALL_PROPERTY_STYLES';
export const GET_ALL_PROPERTY_STYLES_ERROR = 'GET_ALL_PROPERTY_STYLES_ERROR';
